require('./bootstrap');

import {createApp, h} from 'vue';
import { App, plugin } from '@inertiajs/inertia-vue3';
import { Link } from '@inertiajs/inertia-vue3'
// import { Inertia } from '@inertiajs/inertia'
import ZComm from './Modules/z-comm'
import ZUtil from './Modules/z-util'
import { InertiaProgress } from '@inertiajs/progress'
import WaveUI from 'wave-ui'
// import CKEditor from '@ckeditor/ckeditor5-vue';

import 'wave-ui/dist/wave-ui.css'
// import 'font-awesome/css/font-awesome.min.css'

const el = document.getElementById('app');

InertiaProgress.init();

const app = createApp({
    render: () => h(App, {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => require(`./Pages/${name}`).default
    }),
    created() {
        this.$zcomm.app = this
        this.$zutil.app = this
    }
});

// Register a-la-carte components from the given list.
// this to move to the npm later, it's here now easier dev purposesss
import * as components from './Components'
for (let id in components) {
  const component = components[id]
  app.component(component.name, component)
}

new WaveUI(app, {
  // Some Wave UI options.
})


app.config.globalProperties.$route = window.route;
app.provide('$route', window.route);


app.config.globalProperties.service_pay = process.env.MIX_PAY;
app.config.globalProperties.app_url = window.location.protocol + "//" + window.location.host;
app.config.globalProperties.service_utiliti = process.env.MIX_UTILITI;
app.config.globalProperties.bil_cukai = process.env.MIX_BIL_CUKAI;

app.config.globalProperties.$zcomm = new ZComm
app.config.globalProperties.$zutil = new ZUtil

// import ZenOne from './Shared/ZenTwo'
import ZenLanding from './Shared/ZenLanding'

app.use(plugin)
.component('InertiaLink', Link)
// .component('ZenOne', ZenOne)
.component('Layout', ZenLanding)
.mount(el);
